import React, {
  useEffect, useState,
} from 'react'
import { useTranslation } from 'react-i18next'
import Tooltip from 'rc-tooltip'
import { FieldPath, FieldValues } from 'react-hook-form'
import Input from './Input'
import FormSelect from './FormSelect'
import { DEFAULT_FIELD_RULE, FieldRule } from '../../features/declaration/models/fieldRules'

export interface FieldProps<TForm extends FieldValues> {
  labelKey: string
  hidden?: boolean
  className?: string
  // eslint-disable-next-line react/no-unused-prop-types
  scope?: FieldPath<TForm>
  fieldRule?: FieldRule
  // eslint-disable-next-line react/require-default-props
  tooltipContent?: React.ReactNode
  // eslint-disable-next-line react/require-default-props
  tooltipPlacement?: 'top' | 'left' | 'right' | 'bottom' | 'topLeft' | 'topRight'
}
function FormField<TForm extends FieldValues>({
  labelKey, hidden, className, children, fieldRule = DEFAULT_FIELD_RULE, tooltipContent, tooltipPlacement,
}: React.PropsWithChildren<FieldProps<TForm>>) {
  const { t } = useTranslation()
  const [timeZone, setTimeZone] = useState<string>()

  useEffect(() => {
    if (
      React.isValidElement(children)
      && !Array.isArray(children)
      && typeof children.type !== 'string'
      && (children.type === Input || children.type === FormSelect)
      && children.props.type === 'datetime-local'
    ) {
      setTimeZone(Intl.DateTimeFormat().resolvedOptions().timeZone)
    }
  }, [children])

  return (
    <React.Fragment key={labelKey}>
      {
        !hidden
        && (
          <div className={`mb-2 ${className}`}>
            <div className={
              `form-field__label ${
                fieldRule.requirement === 'required' ? 'required' : ''
              } ${
                fieldRule.requirement === 'forbidden' ? 'text-muted cursor--not-allowed' : ''
              }`
            }
            >
              {t(labelKey)}
              {timeZone !== undefined ? (
                <Tooltip overlayClassName="tooltip-lg" placement="left" overlay={<small>{timeZone}</small>}>
                  <button className="btn btn-link btn-gray-700 p-0 h-100" type="button">
                    <i className="fal fa-info-circle ms-1" />
                  </button>
                </Tooltip>
              ) : null}
              {tooltipContent !== undefined ? (
                <Tooltip overlayClassName="tooltip-lg" placement={tooltipPlacement} overlay={<small>{tooltipContent}</small>}>
                  <button className="btn btn-link btn-gray-700 p-0 h-100" type="button">
                    <i className="fal fa-info-circle ms-1" />
                  </button>
                </Tooltip>
              ) : null}

            </div>
            <div>{children}</div>
          </div>
        )
      }
    </React.Fragment>
  )
}

FormField.defaultProps = {
  hidden: false,
  className: '',
  scope: undefined,
  fieldRule: undefined,
}

export default FormField
